const ReviewModule = () => {
  return (
    <div>
      <h4>리뷰 영역</h4>
    </div>
  );
};

export default ReviewModule;
